//FILE VALUES
const MAX_FILES = 10;
const MAX_BATCH_SIZE = 2500 * 1024; // 500 * 1024 = 500 KB
const MAX_FILE_SIZE = 1024 * 1024; // 150 * 1024 = 150 KB
const RESTRICTED_FILES = [
  '.jpg',
  '.jpeg',
  '.heic',
  '.png',
  '.gif',
  '.bmp',
  '.mp4',
  '.avi',
  '.mov',
  '.mkv',
  '.mp3',
  '.wav',
  '.aac',
  '.zip',
  '.rar',
  '.7z',
  '.exe',
  '.dll',

  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
];

//VALIDATE PROGRESS VALUES
const validationTime = 150000;

//BLOCKCHAIN VALUES
// const BASE_FEE = 0.00000001;
// const FEE_DECIMAL_PLACES = 8; // ADJUST BASED ON DECIMAL PLACES
const BASE_FEE = 0.0;
const FEE_DECIMAL_PLACES = 1; // ADJUST BASED ON DECIMAL PLACES
const INTEGRITAS_TREASURY = 'MxG082TTYSYYGFUCVR87ZNAFC4HCJ4VQGPQBKBWHYQNH0337Z5FUBAAHZ5SRCJ2';

const BLOCK_EXPLORER_BASEURL = `https://block.minima.global`;
const BLOCK_EXPLORER_BLOCK_ID_URL = `${BLOCK_EXPLORER_BASEURL}/blocks`;
const BLOCK_EXPLORER_TXN_ID_URL = `${BLOCK_EXPLORER_BASEURL}/transactions`;

const API_INTEGRITAS_BASEURL = `${import.meta.env.VITE_CORE_URL}`;
const VERIFY_ENDPOINT = '/verify/post-lite'; // TODONOW_ change to /verify/post-lite
const API_INTEGRITAS_AUTH = {
  username: 'admin1',
  password: 'password123',
};

// GOOGLE FORM API
const GOOGLE_FORM_API =
  'https://docs.google.com/forms/u/0/d/e/1FAIpQLSc6J2UNqNBLP-vxBD-UK40CExQem5GELY7QWXrysuvJaiiRlQ/formResponse';
const GOOGLE_FORM_ENTRY_IDS = {
  name: 'entry.846734695',
  email: 'entry.1909109855',
  expectedOutcome: 'entry.1923623767',
  actualOutcome: 'entry.1386604635',
  stepsToReproduce: 'entry.942819664',
  priorityLevel: 'entry.1730969656',
  probabilityMotivation: 'entry.2042239588',
  additionalInformation: 'entry.1840045469',
};

// PENDING MESSAGE TXN/NFT
const PENDING_BALANCE_TXN = 'Waiting for sufficient balance to pay transaction...';
const PENDING_BALANCE = 'Transaction pending';
const PENDING_BALANCE_NFT = 'Waiting for sufficient balance to mint NFT...';
const PENDING_NFT = 'Transaction NFT pending';

export const VITE_BASE_URL = import.meta.env.VITE_BASE_URL || 'http://localhost:3000';

export {
  API_INTEGRITAS_BASEURL,
  VERIFY_ENDPOINT,
  API_INTEGRITAS_AUTH,
  GOOGLE_FORM_API,
  GOOGLE_FORM_ENTRY_IDS,
  INTEGRITAS_TREASURY,
  MAX_FILE_SIZE,
  MAX_BATCH_SIZE,
  RESTRICTED_FILES,
  MAX_FILES,
  BASE_FEE,
  FEE_DECIMAL_PLACES,
  validationTime,
  PENDING_BALANCE_TXN,
  PENDING_BALANCE,
  PENDING_BALANCE_NFT,
  PENDING_NFT,
  BLOCK_EXPLORER_BLOCK_ID_URL,
  BLOCK_EXPLORER_TXN_ID_URL,
};
